import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CodigoPerfil } from '../constants/codigoPerfil';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdmProfileGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const profile = this.authService.getProfileSelected()

    if (
      profile && (profile.codigo == CodigoPerfil.ADMIN)
    ) return true

    this.router.navigate(['login'])
    return true;
  }
}
